module.exports = __webpack_public_path__ + "static/media/pencil-paper.92af97f5.png";